import __request__ from "routing/request";
export function update(profile, requestOptions) {
  return __request__("PUT", "/system/indices/index_sets/profiles", profile, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function create(profileData, requestOptions) {
  return __request__("POST", "/system/indices/index_sets/profiles", profileData, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getAll(requestOptions) {
  return __request__("GET", "/system/indices/index_sets/profiles/all", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getPage(sort = "name", page = 1, per_page = 50, query, filters, order = "asc", requestOptions) {
  return __request__("GET", "/system/indices/index_sets/profiles/paginated", null, { "page": page, "per_page": per_page, "query": query, "filters": filters, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(profile_id, requestOptions) {
  return __request__("DELETE", `/system/indices/index_sets/profiles/${profile_id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function retrieveById(profile_id, requestOptions) {
  return __request__("GET", `/system/indices/index_sets/profiles/${profile_id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
